import { Header } from "./Header";
import { Footer } from "./Footer";
import { Toaster } from "../components/ui/sonner";

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-linen text-ink">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <Toaster position="bottom-right" />
    </div>
  );
};

export default Layout;
